import PropTypes from 'prop-types'
import React, { Component } from 'react'

const weekdays = [
  'Sonntag',
  'Montag',
  'Dienstag',
  'Mittwoch',
  'Donnerstag',
  'Freitag',
  'Samstag',
]

export default class CommaSeparatedList extends Component {

  static propTypes = {
    list: PropTypes.array,
    type: PropTypes.string,
  }

  render() {

    const { type, list } = this.props

    const dataList = window.APP_CONFIG[`list_${type}`]

    let entries = ''

    if (type === 'day') {

      if (list.length === 8) {
        entries = 'täglich (auch feiertags)'
      }
      else if (
        weekdays.every((weekday, index) => (list || []).find((entry) => entry.id === index))
      ) {
        entries = 'täglich'
      }
    }

    if (type !== 'day' || !entries) {
      entries = (list || []).map((entry) => {
        const value = dataList.find((dataListEntry) => dataListEntry.id === entry.id)
        return (
          <span
            key={entry.id}
            className="comma-separated-list-entry"
          >
            {value.title}
            <span className="separator">, </span>
          </span>
        )
      })
    }

    return (
      <span className="comma-separated-list">
        {entries}
      </span>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/shared/components/CommaSeparatedList.js